export const getCurrencyRate = (currencies, symbol) => {
  const currency = (currencies || []).find((item) => item.symbol === symbol);
  const rate = Number(currency?.rate);

  return Number.isFinite(rate) && rate > 0 ? rate : null;
};

export const formatUsdAndGel = (value, currencies, usdFractionDigits = null) => {
  const parsedValue = Number(value);
  const amount = Number.isFinite(parsedValue) ? parsedValue : 0;
  const usdAmount = Number.isInteger(usdFractionDigits)
    ? amount.toFixed(usdFractionDigits)
    : String(amount);
  const gelRate = getCurrencyRate(currencies, "₾");

  if (gelRate == null) {
    return `${usdAmount} $`;
  }

  return `${usdAmount} $ / ${(amount * gelRate).toFixed(2)} ₾`;
};
